export default {
  sortOptions(model) {

    switch (model) {
      case 'property' :

        return [
          { value : 'price_asc', data : { price : { order : 'asc' } } },
          { value : 'price_desc', data : { price : { order : 'desc' } } },
          { value : 'created_at_asc', data : { createdAt : { order : 'asc' } } },
          { value : 'created_at_desc', data : { createdAt : { order : 'desc' } } },
          { value : 'updated_at_asc', data : { updatedAt : { order : 'asc' } } },
          { value : 'updated_at_desc', data : { updatedAt : { order : 'desc' } } }
        ];

      case 'mandate' :

        return [
          { value : 'price_asc', data : { 'price.current.value' : { order : 'asc' } } },
          { value : 'price_desc', data : { 'price.current.value' : { order : 'desc' } } },
          { value : 'created_at_asc', data : { createdAt : { order : 'asc' } } },
          { value : 'created_at_desc', data : { createdAt : { order : 'desc' } } },
          { value : 'updated_at_asc', data : { updatedAt : { order : 'asc' } } },
          { value : 'updated_at_desc', data : { updatedAt : { order : 'desc' } } },
          { value : 'expiry_date_at_asc', data : { expiryDate : { order : 'asc' } } }
        ];

      case 'client':

        return [
          { value : 'lastName_asc', data : { 'lastName.keyword' : { order : 'asc' } } },
          { value : 'lastName_desc', data : { 'lastName.keyword' : { order : 'desc' } } },
          { value : 'created_at_asc', data : { createdAt : { order : 'asc' } } },
          { value : 'created_at_desc', data : { createdAt : { order : 'desc' } } },
          { value : 'updated_at_asc', data : { updatedAt : { order : 'asc' } } },
          { value : 'updated_at_desc', data : { updatedAt : { order : 'desc' } } },
          { value : 'relevance', data : { relevance : { order : 'asc' } } }
        ];

      case 'company' :

        return [
          { value : 'created_at_asc', data : { createdAt : { order : 'asc' } } },
          { value : 'created_at_desc', data : { createdAt : { order : 'desc' } } },
          { value : 'updated_at_asc', data : { updatedAt : { order : 'asc' } } },
          { value : 'updated_at_desc', data : { updatedAt : { order : 'desc' } } },
          { value : 'relevance', data : { relevance : { order : 'asc' } } }
        ];

      case 'thread' :

        return [
          { value : 'created_at_asc', data : { createdAt : { order : 'asc' } } },
          { value : 'created_at_desc', data : { createdAt : { order : 'desc' } } },
          { value : 'updated_at_asc', data : { updatedAt : { order : 'asc' } } },
          { value : 'updated_at_desc', data : { updatedAt : { order : 'desc' } } }
        ];

      case 'appointment':

        return [
          { value : 'created_at_asc', data : { createdAt : { order : 'asc' } } },
          { value : 'created_at_desc', data : { createdAt : { order : 'desc' } } },
          { value : 'start_at_asc', data : { start_at : { order : 'asc' } } },
          { value : 'start_at_desc', data : { start_at : { order : 'desc' } } }
        ];

      case 'avenant' :

        return [
          { value : 'created_at_asc', data : { createdAt : { order : 'asc' } } },
          { value : 'created_at_desc', data : { createdAt : { order : 'desc' } } },

          { value : 'number_asc', data : { number : { order : 'asc' } } },
          { value : 'number_desc', data : { number : { order : 'desc' } } },
          { value : 'updated_at_asc', data : { updatedAt : { order : 'asc' } } },
          { value : 'updated_at_desc', data : { updatedAt : { order : 'desc' } } }
        ];

      case 'timemachine' :

        return [
          { value : 'created_at_asc', data : { createdAt : { order : 'asc' } } },
          { value : 'created_at_desc', data : { createdAt : { order : 'desc' } } }
        ];

      case 'registryMandate' :

        return [
          { value : 'numero_ordre_asc', data : { numero_ordre : { order : 'asc' } } },
          { value : 'numero_ordre_desc', data : { numero_ordre : { order : 'desc' } } },
          { value : 'date_mandat_asc', data : { date_mandat : { order : 'asc' } } },
          { value : 'date_mandat_desc', data : { date_mandat : { order : 'desc' } } }
        ];

      case 'property_offer' :

        return [
          { value : 'created_at_asc', data : { createdAt : { order : 'asc' } } },
          { value : 'created_at_desc', data : { createdAt : { order : 'desc' } } },
          { value : 'updated_at_asc', data : { updatedAt : { order : 'asc' } } },
          { value : 'updated_at_desc', data : { updatedAt : { order : 'desc' } } },
          { value : 'vendor_signature_date_asc', data : { vendorSignatureDate : { order : 'asc' } } },
          { value : 'vendor_signature_date_desc', data : { vendorSignatureDate : { order : 'desc' } } }
        ];

      default :

        return [
          { value : 'updated_at_asc', data : { updatedAt : { order : 'asc' } } },
          { value : 'updated_at_desc', data : { updatedAt : { order : 'desc' } } },
          { value : 'created_at_asc', data : { createdAt : { order : 'asc' } } },
          { value : 'created_at_desc', data : { createdAt : { order : 'desc' } } }
        ];
    }
  }
};
